<template>
  <div>
    <div v-if="nav">
      <div class="nav nav-pills">
        <a class="nav-item nav-link c-search-bar__link" href="javascript://"
          :class="type === 'organization' ? 'active' : ''" @click="switchTab('organization')">
            <span class="d-none d-sm-inline">
                <i class="far fa-school"></i>
            </span>
          <span>找機構</span>
        </a>
        <a href="javascript://" class="nav-item nav-link c-search-bar__link"
          :class="type === 'lesson' ? 'active' : ''" @click="switchTab('lesson')">
            <span class="d-none d-sm-inline">
                <i class="far fa-chalkboard-teacher"></i>
            </span>
          <span>找課程</span>
        </a>
        <a v-if="position !== 'home'" href="javascript://" class="nav-item nav-link c-search-bar__link"
          :class="type === 'article' ? 'active' : ''" @click="switchTab('article')">
            <span class="d-none d-sm-inline">
              <i class="far fa-newspaper"></i>
            </span>
          <span>找文章</span>
        </a>
      </div>
    </div>

    <div class="c-bar">
      <div class="c-bar__wrapper d-lg-flex justify-content-between align-items-center">
        <!--City Selector-->
        <div v-if="type !== 'article'" class="c-city-selector w-100 position-relative">
          <Selector
            :key="'city-selector'"
            :title="'地區'"
            :multiple="true"
            :target-options="cityOptions"
            :max="5"
            :selected-value="citySelected"
            @change="setCityValue">
          </Selector>
        </div>

        <!--Age Selector-->
        <div v-if="type === 'lesson'" class="w-100 position-relative">
          <Selector
            :key="'age-selector'"
            :title="'年齡'"
            :multiple="true"
            :target-options="ageOptions"
            :max="3"
            :selected-value="ageSelected"
            @change="setAgeValue">
          </Selector>
        </div>

        <!--Category Selector-->
        <CategorySelector
          v-if="type !== 'article'"
          class="w-100"
          :type="type"
          :age-selected="ageSelected"
          :max="getCategoryMax()"
          :selected-value="categorySelected"
          @change="setCategoryValue"
        >
        </CategorySelector>

        <!--<div v-if="type === 'article'" class="w-100 position-relative c-tag-selector">-->
        <!--  <Selector-->
        <!--    :key="'tag-selector'"-->
        <!--    :title="'文章標籤'"-->
        <!--    :multiple="true"-->
        <!--    :target-options="tagOptions"-->
        <!--    :max="3"-->
        <!--    :selected-value="tagSelected"-->
        <!--    @change="setTagValue">-->
        <!--  </Selector>-->
        <!--</div>-->

        <div
          class="c-bar__cell position-relative"
          v-if="type === 'lesson' && position !== 'home'"
          @click="toggleDatepicker"
        >
          <div class="c-bar__cell-inner">
            <div class="c-bar__cell-body">
              <div class="c-bar__text">
                <div class="c-bar__title">開課日期</div>
                <div class="c-bar__placeholder">
                  <date-picker
                    ref="datepicker"
                    v-model="dateRange"
                    range
                    placeholder="請選擇日期"
                    value-type="format"
                    format="YYYY-MM-DD"
                    :open="openState"
                    :close-on-select="false"
                  >
                  </date-picker>
                </div>
              </div>
              <div class=""><i class="fas fa-angle-down"></i></div>
            </div>
          </div>
        </div>

        <div class="c-bar__cell position-relative" v-if="keyword">
          <div class="c-bar__cell-inner">
            <div class="c-bar__cell-body">
              <div class="c-bar__text">
                <div class="c-bar__title">關鍵字</div>
                <input class="c-bar__input" type="text" v-model="q" placeholder="請輸入關鍵字"
                  @keyup.enter="search"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="position-relative">
          <a href="javascript://" class="c-bar__btn" @click.stop="search">
            <span v-if="isMobile" class="me-2">搜尋</span>
            <i class="fas fa-search pb-lg-1"></i>
          </a>
        </div>
      </div>
      <div v-if="clear" class="d-flex justify-content-end align-items-center">
        <a href="javascript://" @click="clearAll" class="text-primary">
            <span class="me-1">
              清除條件
            </span>
          <i class="fas fa-rotate-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
const { reactive, toRefs, computed, onMounted, ref } = Vue;
import Selector from '../../components/front/search-bar/Selector';
import CategorySelector from '../../components/front/search-bar/CategorySelector';
import DatePicker from 'vue2-datepicker';
import mobileCheck from '../../services/utilities';
import MessageBox from 'element-ui/lib/message-box';

export default {
  name: 'search-bar-app',
  components: {
    Selector,
    CategorySelector,
    DatePicker,
  },
  props: {
    selectorType: {
      type: String,
      default: 'organization'
    },
    position: {
      type: String,
      default: 'global'
    },
    nav: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      default: false
    },
  },
  setup(props) {
    const layoutState = reactive({
      type: props.selectorType,
      hasKeyword: false,
    });

    const state = reactive({
      citySelected: u.data('city') ?? [],
      ageSelected: u.data('age') ?? [],
      categorySelected: u.data('category') ?? [],
      dateRange: u.data('date') ?? [],
      tagSelected: u.data('tag') ?? [],
      q: u.data('q') ?? '',
      isMobile: null,
      openState: false,
    });

    mobileCheck(state);

    const datepicker = ref(null);

    const cityOptions = u.data('cityOptions');
    const ageOptions = u.data('ageOptions');
    // const tagOptions = u.data('tagOptions');
    let params = {};

    const search = async (e) => {
      params.q = state.q;

      if (props.position === 'global') {
        params.type = layoutState.type;
      }

      if (state.citySelected.length) {
        params.city = JSON.stringify(state.citySelected);
      }

      if (state.ageSelected.length) {
        params.age = JSON.stringify(state.ageSelected);
      }

      if (state.dateRange.length) {
        params.date = JSON.stringify(state.dateRange);
      }

      if (
          state.categorySelected.length
          && (props.position !== 'home' || (props.position === 'home' && layoutState.type !== 'organization') )
      ) {
        params.category = JSON.stringify(state.categorySelected);
      }

      if (state.tagSelected.length) {
        params.tag = JSON.stringify(state.tagSelected);
      }

      if (props.position === 'global') {
        const router = u.route('search_ajax');

        const res = await u.$http.get(
          router,
          { params: params }
        );

        window.location.href = res.data.data.data;
      }

      if (props.position !== 'global' && layoutState.type === 'lesson') {
        window.location.href = u.route('lesson_list', params);
      }

      if (props.position !== 'global' && layoutState.type === 'organization') {
        if (!state.categorySelected.length) {
          await MessageBox.alert('請先選擇分類', '', {
            confirmButtonText: '確定',
            callback: action => {
              e.preventDefault();
            }});
        }

        // console.log();
        const res = await u.$http.get(
          u.route('get_category_path'),
          { params: { id: state.categorySelected.toString() } }
        );

        params.path = res.data.data.data;

        window.location.href = u.route('org_list', params);
      }
    };

    const switchTab = (type) => {
      layoutState.type = type;
    };

    const setCityValue = (v) => {
      state.citySelected = v;
    };

    const setAgeValue = (v) => {
      state.ageSelected = setValue(v);
    };

    const setCategoryValue = (v) => {
      state.categorySelected = setValue(v);
    };

    const getCategoryMax = () => {
      if (props.position === 'home' && layoutState.type === 'organization') {
        return 1;
      }

      return 3
    }

    const setTagValue = (v) => {
      state.tagSelected = setValue(v);
    };

    const clearAll = async () => {
      state.q = '';
      state.categorySelected = [];
      state.citySelected = [];
      state.ageSelected = [];
      state.dateRange = [];
      state.tagSelected = [];

      if (props.position === 'global') {
        const router = u.route('search_ajax');
        const res = await u.$http.get(router);

        window.location.href = res.data.data.data;
      } else {
        window.location.href = u.route('lesson_list');
      }
    };

    const setValue = (v) => {
      let res = [];
      v.map((e) => {
        res = res.concat(e);
      });

      return Array.from(new Set(res));
    };

    function toggleDatepicker() {
      state.openState = !state.openState;
    }

    return {
      ...toRefs(layoutState),
      ...toRefs(state),
      cityOptions,
      ageOptions,
      // tagOptions,

      // Function
      switchTab,
      setCityValue,
      setAgeValue,
      // setTagValue,
      getCategoryMax,
      setCategoryValue,
      clearAll,
      search,

      toggleDatepicker,
      datepicker
    };
  }
};
</script>

<style scoped>

</style>
